const every = (predicate) => (array) => array.every(predicate);
const some = (predicate) => (array) => array.some(predicate);
const map = (mapper) => (array) => array.map(mapper);
function filter(predicate) {
    return (array) => array.filter(predicate);
}
const reduce = (reducer, initialValue) => (array) => array.reduce(reducer, initialValue);
const filterType = (predicate) => (array) => array.filter(predicate);
const isEmpty = () => (array) => array.length === 0;
const limit = (n) => (array) => n !== undefined ? array.slice(0, n) : array;
const reverse = () => (array) => [...array].reverse();
export const List = {
    every,
    some,
    map,
    filter,
    reduce,
    filterType,
    isEmpty,
    limit,
    reverse,
};
//# sourceMappingURL=List.js.map